<template>
  <div class="text-left mt-15 pr-10rem">
    <el-form :rules="rules" ref="ruleForm" :model="form" label-width="auto">
      <el-form-item :label="$t('反馈标题')" prop="title">
        <el-input :placeholder="$t('请填写标题')" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item :label="$t('需求内容')" prop="content">
        <el-input class="textarea" type="textarea" :placeholder="$t('请输入您在使用过程中所遇到的问题')" maxlength="200" show-word-limit
          v-model="form.content" ></el-input>
      </el-form-item>
      <p class="pl-5rem text-sm text-gray-400 pb-3rem">
        {{ $t("字数限制在15-200字") }}
      </p>
      <el-form-item :label="$t('联系方式')" prop="phone">
        <el-input :placeholder="$t('请填写手机号/邮箱')" v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t("发送") }}</el-button>
        <el-button>{{ $t("取消") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { ref } from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const form = ref({
      content: "",
      title: "",
      phone: "",
    });
    const rules = {
      content: [
        {
          required: true,
          message: ctx.root.$t("请输入反馈内容"),
          trigger: "blur",
        },
        {
          min: 15,
          max: 200,
          message: ctx.root.$t("长度在 15到 200 个字符"),
          trigger: "blur",
        },
      ],
      phone: [
        {
          required: true,
          message: ctx.root.$t("请输入手机号"),
          trigger: "blur",
        },
      ],
      title: [
        {
          required: true,
          message: ctx.root.$t("请输入反馈标题"),
          trigger: "blur",
        },
      ],
    };
    const onSubmit = () => {
      ctx.refs.ruleForm.validate(async (valid) => {
        if (valid) {
          ctx.root.$doing();
          const res = await ctx.root.$callapi("user/saveFeedback", form.value);
          ctx.root.$done();
          if (res.code == 0) {
            ctx.root.$toast(ctx.root.$t("反馈提交成功"), "success");
            form.value = {};
          }
        } else {
          return false;
        }
      });
    };
    return {
      rules,
      form,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="scss">.el-textarea ::v-deep .el-textarea__inner {
  height: 15rem;
  color: #606266;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
::v-deep .el-form-item__label {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}</style>